module.exports = __webpack_public_path__ + "static/media/catalyst-circle.6ed9436e.svg";